// このファイルは「VoiceBizRemoteプライバシーポリシー.docx」の本文を機械的に抽出したもの。
// 文言は原本から一字一句変更しないこと（空白・全角記号を含む）。
export type PolicyRun = {
  text: string;
  bold?: boolean;
  underline?: boolean;
  // 原本で本文（10.5pt）と異なるフォントサイズが指定されている箇所（pt）
  size?: number;
};

export type PolicyParagraph = {
  align?: 'left' | 'center' | 'right';
  // Wordの自動段落番号
  number?: string;
  // 空文字は原本の空行
  runs: string | PolicyRun[];
};

export const bodyParagraphs: PolicyParagraph[] = [
  { align: 'right', runs: '2026年11月1日' },
  { align: 'right', runs: 'TOPPAN株式会社' },
  { align: 'right', runs: '' },
  { runs: '' },
  {
    align: 'center',
    runs: [
      {
        text: '「VoiceBiz® Remote」サービスにおけるプライバシーポリシー',
        bold: true,
        underline: true,
        size: 12.0,
      },
    ],
  },
  {
    align: 'left',
    runs: [
      { text: '本プライバシーポリシーは、TOPPAN株式会社（以下、TOPPAN）' },
      { text: 'が提供する「VoiceBiz® Remote', size: 10.0 },
      {
        text: '」（以下、本サービス）において、TOPPANが取得した情報の取扱いについて説明するものです。',
      },
    ],
  },
  { align: 'left', runs: '' },
  { number: '1.', runs: '当社が取得する情報' },
  {
    runs: '本サービスは、利用者が保有する個人情報（生存する個人に関する情報で、氏名、生年月日、住所、顔写真などにより特定の個人を識別できる情報など）を取り扱うことを予定していません。',
  },
  {
    align: 'left',
    runs: '本サービスは利用者の発話内容の音声認識をおこない、発話内容を文字情報として変換し、サーバはアプリケーションに文字情報を配信後、サーバ上の文字情報は一時的に保存されます。',
  },
  {
    runs: 'したがって、本サービスが個人情報を原則として取り扱うことがない予定にかかわらず、利用者の発話内容に個人情報が含まれていた場合、例外的に、個人情報はサーバに一時的に保存されます。',
  },
  {
    runs: '利用者は、利用者の発話内容によっては個人情報がサーバに保存されることを理解したうえで、本サービスを利用するものとします。',
  },
  {
    runs: 'TOPPANは、利用者の発話内容によっては個人情報が含まれる可能性があることを理解したうえで、個人情報の保護に関する法律、その他個人情報の保護に関する法令、ガイドライン等に従い、適切に管理するものとします。',
  },
  {
    runs: 'また、TOPPANの個人情報保護方針及び個人情報に関する苦情相談窓口については当社ホームページの個人情報保護方針（https://www.toppan.com/ja/privacy.html）に掲載します。',
  },
  {
    runs: '当社は、お客様から取得した個人情報を厳重に管理・保護いたします。不正なアクセスまたは紛失、破壊、改ざん、漏えい等から個人情報を保護するために、社内規程類に基づき、以下の安全管理のための措置を講ずるとともに、万一問題が発生した場合には適切かつ速やかに対処いたします。',
  },
  { runs: '' },
  { runs: '（基本方針の策定）' },
  {
    runs: '当社では個人情報の保護が、個人の権利を全うするため、さらにはお客様の信頼に応えるための、経営上の重要課題であることを、「TOPPAN株式会社 個人情報保護方針」として定め、全部門に徹底します。',
  },
  { runs: '（個人データの取扱いに関する規律の整備）' },
  {
    runs: '当社が取得する個人情報を、確実に受領・取得、処理・加工、返却・納品・廃棄するための役員および従業員等の遵守事項を確実にすることを目的として、個人データの取扱に関するルールを定めています。',
  },
  { runs: '（組織的安全管理措置）' },
  {
    runs: '当社では個人情報保護管理者を定めるとともに、個人データを取り扱う従業者及び当該従業者が取り扱う個人データの範囲を明確化し、法や取扱ルールに違反している事実又は兆候を把握した場合の責任者への報告連絡体制を整備しています。また、個人データの取扱い状況について、定期的に自己点検および内部監査の実施や、外部の監査を受けています。',
  },
  { runs: '（人的安全管理措置）' },
  {
    runs: '当社では個人データの取扱いに関する留意事項について、役員および従業員等に定期的な教育を実施するとともに、個人データについての秘密保持に関する誓約を取得し、これらに違反した場合の罰則規定を就業規則に定めています。',
  },
  { runs: '（物理的安全管理措置）' },
  {
    runs: '当社では個人データを取り扱う区域を定め、役員および従業員等の入退室管理および持ち込む機器の制限を実施するとともに、権限を有しない者が個人データを閲覧することができない措置を実施しています。また、個人データを扱う機器の持ち出しや紛失、盗難を防止するための措置、電子媒体の持ち込み制限を実施するとともに、容易に個人データが判明しないよう措置を実施しています。',
  },
  { runs: '（技術的安全管理措置）' },
  {
    runs: '当社では個人データを扱う情報システムは外部からの不正アクセスの防止や、不正ソフトウェアから保護する仕組みを導入し、アクセス制御により、個人データの取扱い担当者および個人情報データベース等の範囲を定めています。',
  },
  { runs: '（外的環境の把握）' },
  {
    runs: '当社では個人データを保管している日本国における個人情報の保護に関する制度を把握した上で安全管理措置を実施しています。',
  },
  { runs: '' },
  { align: 'left', runs: '(1)利用者が提供する情報' },
  { align: 'left', runs: '■入力情報　※翻訳機能を提供するために利用。' },
  {
    align: 'left',
    runs: '・翻訳するために利用者が入力する音声情報・テキスト情報',
  },
  { align: 'left', runs: '・言語情報（入力した言語と翻訳を実行したい言語）' },
  { align: 'left', runs: '' },
  {
    align: 'left',
    runs: '■ID/PASS情報　※一部機能を利用する上で、許可された利用者であるか判別するために利用。',
  },
  {
    align: 'left',
    runs: '・本サービス利用に当たり必要なID/PASSWORD情報（一部利用者のみ）',
  },
  { align: 'left', runs: '' },
  { align: 'left', runs: '(2)自動的に取得される情報' },
  { align: 'left', runs: '■利用情報　※サポート、サービス向上のために利用。' },
  { align: 'left', runs: '・端末モデル・OSバージョン情報' },
  { align: 'left', runs: '・開始時間' },
  { align: 'left', runs: '・IPアドレス' },
  { align: 'left', runs: '' },
  { runs: '2. cookieについて' },
  {
    runs: '本サービスでは、「情報提供」「サービスの充実」「本サービスの利便性向上」などの目的ために、cookieを使用する場合があります。本サービスは、cookieによって個人を特定できるような情報を得ることはありません。',
  },
  { runs: '' },
  { runs: '3．情報の使用方法' },
  {
    align: 'left',
    runs: '利用者が提供する情報に関しては、サービス提供のため、国内サーバにて処理を実行します。',
  },
  {
    runs: '弊社が自動的に取得する情報に関しては、サポートや本サービス利用傾向の把握、サービス向上のため使用します。',
  },
  { runs: '' },
  { runs: '4. 情報の共有や連携' },
  {
    runs: '当社は、本サービスの運営・保守を委託する外部業者に、お客様の情報を委託する場合があります。その場合には、当社は当該外部業者と秘密保持契約を締結し、お客さまの情報の管理を徹底いたします。',
  },
  { runs: '' },
  {
    runs: [
      { text: 'また当社は、' },
      { text: '博覧会協会に個人情報を除く', size: 10.0 },
      { text: '利用' },
      { text: '情報を提供します。', size: 10.0 },
    ],
  },
  {
    runs: [
      { text: 'ただし、', size: 10.0 },
      { text: '以下の場合は' },
      { text: '博覧会協会以外の', size: 10.0 },
      { text: '第三者に情報を開示する場合があります。 ' },
    ],
  },
  { runs: '(1)お客さまから予め同意をいただいている場合 ' },
  {
    runs: '(2)公共の利益の保護又は公権力により開示を求められ、法的に開示を拒めない場合 ',
  },
  {
    runs: '(3)お客さまおよびその他の個人の生命、身体または財産等に対する差し迫った危険に対処するため､やむを得ず利用する場合 ',
  },
  {
    runs: '(4)お客さまの行った行為により、損害を被った又はその恐れがあると主張する第三者から要請があり、相当の理由があると当社が判断した場合 ',
  },
  {
    runs: '(5)当社の業務委託先が、当社に代わりアフターサービスなどの個別の役務を提供するために必要がある場合 ',
  },
  { runs: '' },
  { runs: '5. データの越境移転' },
  {
    runs: '本サービスを利用することで入力された全ての情報（音声、テキスト、翻訳結果、通信履歴、位置情報など）は日本国内のサーバに蓄積されますが、限定された人員のみアクセスが可能です。また国外への情報の移転は行いません。取得した情報は、本サービスを提供するため、及び利用者に提供する範囲において本サービスを向上との関係で必要となった場合を除き、TOPPANが第三者（第4条の委託先を除きます。）に提供することはございません。',
  },
  { runs: '' },
  { runs: '6. 情報セキュリティ' },
  {
    runs: '取得した情報については、漏洩、減失または毀損の防止と是正、その他情報の安全管理のために必要かつ適切な措置を講じます。本サービスは、SSL（Secure Socket Layer）による暗号化措置を講じています。',
  },
  { runs: '' },
  { runs: '7.問い合わせ' },
  { runs: '受付時間10:00～17:00（土・日・祝・当社休業日を除く）' },
  {
    runs: '個人情報に関するお問い合わせは、「個人情報の取扱いについて」をお読みいただき、同意の上、下記連絡先にご連絡ください。',
  },
];

// 枠線付きテキストボックス内の段落（この後ろにメールアドレス画像が続く）
export const contactBoxParagraphs: PolicyParagraph[] = [
  { runs: '【個人情報に関するお問い合わせ先】' },
  {
    runs: 'TOPPAN株式会社　情報コミュニケーション事業本部セキュリティ管理本部',
  },
  { runs: '情報セキュリティ管理責任者' },
];

export const closingParagraphs: PolicyParagraph[] = [
  {
    runs: '当社の名称、住所および代表者の氏名に関しては、当社コーポレートサイトの「会社概要」ページ（https://www.toppan.com/ja/about-us/overview.html）から確認できます。',
  },
];
